import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    AUTH_COOKIE_SECURE: z.coerce.boolean().optional(),
    API_BASE_URL: z.url().optional(),
    HOTEL_GEOCODER_EMAIL: z.string().email().optional(),
    HOTEL_GEOCODER_URL: z.url().optional(),
    HOTEL_GEOCODER_USER_AGENT: z.string().min(1).optional(),
  },

  client: {
    NEXT_PUBLIC_APP_URL: z.url(),
    NEXT_PUBLIC_API_BASE_URL: z.url(),
    NEXT_PUBLIC_SERVER_FILE_UPLOAD_URL: z.url(),
    NEXT_PUBLIC_SOCKET_URL: z.url().optional(),
    NEXT_PUBLIC_SOCKET_PATH: z.string().min(1).optional(),
  },

  runtimeEnv: {
    AUTH_COOKIE_SECURE: process.env.AUTH_COOKIE_SECURE,
    API_BASE_URL: process.env.API_BASE_URL,
    HOTEL_GEOCODER_EMAIL: process.env.HOTEL_GEOCODER_EMAIL,
    HOTEL_GEOCODER_URL: process.env.HOTEL_GEOCODER_URL,
    HOTEL_GEOCODER_USER_AGENT: process.env.HOTEL_GEOCODER_USER_AGENT,

    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    NEXT_PUBLIC_SERVER_FILE_UPLOAD_URL:
      process.env.NEXT_PUBLIC_SERVER_FILE_UPLOAD_URL,
    NEXT_PUBLIC_SOCKET_URL: process.env.NEXT_PUBLIC_SOCKET_URL,
    NEXT_PUBLIC_SOCKET_PATH: process.env.NEXT_PUBLIC_SOCKET_PATH,
  },
});
